<div class="px-5 pb-5">
  <h1 class="cbb-page-title mb-4">Cotizaciones Cemento</h1>
  <app-cotizacion-cemento-tabla></app-cotizacion-cemento-tabla>
</div>
